module.exports = __webpack_public_path__ + "img/6.716e4d15.jpg";